import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "target"];

  static values = {
    // The CSS class to add/remove (e.g., 'hidden', 'd-none')
    toggleClass: { type: String, default: "hidden" },
    // The data-* attribute on the target elements used for matching the trigger's value.
    // Example: if trigger value is 'credit_card', it looks for a target with
    // `data-toggle-match-value="credit_card"` (or whatever attribute is specified here).
    // Note: Use kebab-case here, it maps to dataset.yourAttributeName in JS
    matchAttribute: { type: String, default: "value" }
  }

  connect() {
    // Ensure initial state is correct based on the trigger's default value
    this.update();
    // Optional: Add listener if trigger isn't the controller element itself
    // and doesn't have a data-action defined externally.
    if (this.hasTriggerTarget) {
      this.triggerTarget.addEventListener('change', this.update.bind(this));
    }
  }

  update(event) {
    // Use event?.target if triggered by an action, otherwise use the triggerTarget
    const triggerElement = event?.target || (this.hasTriggerTarget ? this.triggerTarget : null);
    if (!triggerElement) {
      console.warn("ToggleController: No trigger element found.");
      return;
    }

    const currentValue = triggerElement.value;
    const toggleClass = this.toggleClassValue;
    // Convert kebab-case attribute name (e.g., 'payment-method') to camelCase ('paymentMethod') for dataset access
    const matchAttributeKey = this.matchAttributeValue.replace(/-([a-z])/g, g => g[1].toUpperCase());

    // console.log(`ToggleController: Trigger value is "${currentValue}". Toggling class "${toggleClass}". Matching on "data-${this.matchAttributeValue}".`);

    this.targetTargets.forEach(element => {
      const elementMatchValue = element.dataset[matchAttributeKey];
      const shouldBeVisible = elementMatchValue === currentValue;

      // console.log(` Target element with value "${elementMatchValue}": Should be visible? ${shouldBeVisible}`);

      // Add the class if it should NOT be visible, remove it if it SHOULD be visible.
      element.classList.toggle(toggleClass, !shouldBeVisible);
    });
  }

  // Optional: If the trigger element might disconnect, clean up listeners
  disconnect() {
    if (this.hasTriggerTarget) {
      this.triggerTarget.removeEventListener('change', this.update.bind(this));
    }
  }
}
